import type { JSX } from "react";
interface HipelifeLogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
}

export function HipelifeLogo({
  size = 48,
  className = "",
  showText = false,
}: HipelifeLogoProps): JSX.Element {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Hipelife logo"
      >
        {/* Rounded square background - indigo-600 */}
        <rect width="48" height="48" rx="8" fill="#4F46E5" />

        {/* HPL text in white */}
        <text
          x="24"
          y="24"
          fontFamily="system-ui, -apple-system, sans-serif"
          fontSize="20"
          fontWeight="700"
          fontStyle="italic"
          fill="white"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          HPL
        </text>
      </svg>

      {showText && (
        <span className="text-xl font-bold text-gray-900 font-display tracking-tight">
          Hipelife
        </span>
      )}
    </div>
  );
}
